import * as React from 'react';
import {FunctionComponent} from 'react';
import {faPause, faSync} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {FlatListState} from './flats/FlatListState';
import {observer} from 'mobx-react-lite';

export interface PauseButtonComponentProps {
    state: FlatListState;
}

export const PauseButtonComponent: FunctionComponent<PauseButtonComponentProps> = observer(({state}) => (
    <ul className="bg-m-gray-2 mr-3 rounded ml-2">
        <li className="inline-block px-1 py-px">
            <button
                className={
                    `font-normal font-roboto-regular px-1 rounded-md text-sm sm:text-base ${state.pauseListRefresh ? 'btn-primary font-bold' : ''}`
                }
                onClick={() => {
                    state.togglePauseListRefresh();
                }}
                title={'Pause list refresh'}
            >
                <FontAwesomeIcon icon={faPause}/>
            </button>
            <button
                className="font-normal font-roboto-regular px-1 rounded-md text-sm sm:text-base"
                onClick={() => {
                    state.loadList();
                }}
                title={'Reload list'}
            >
                <FontAwesomeIcon icon={faSync}/>
            </button>
        </li>
    </ul>
));
